export const checkHttp = () => {
	if (window.location.protocol === 'http:') {
		return window.location.href = window.location.href.replace('http:','https:');	
	} 
}

